import React from 'react';

import { citations, reactions, tgitems } from '@Constants';

import AvailableRelativeContextButton from './AvailableRelativeContextButton';


export default function SubstanceRelativeContextsList (props) {
  const {
    availableRelativeContext,
  } = props;

  const citationsItem = availableRelativeContext.get(citations);
  const reactionsItem = availableRelativeContext.get(reactions);
  const tgitemsItem = availableRelativeContext.get(tgitems);

  return (
    <>
      {
        citationsItem && (
          <>
            <span className="u-els-display-none@desktop">out of&nbsp;</span>
            <AvailableRelativeContextButton {...props} item={citationsItem}/>
          </>
        )
      }
      {
        reactionsItem && (
          <>
            ,
            <span className="u-els-display-none@desktop">
              &nbsp;containing
            </span>
            &nbsp;
            <AvailableRelativeContextButton {...props} item={reactionsItem}/>
          </>
        )
      }
      {
        tgitemsItem && (
          <>
            ,&nbsp;
            <AvailableRelativeContextButton {...props} item={tgitemsItem}/>
          </>
        )
      }
    </>
  );
}
